import React from 'react'
import PropTypes from 'prop-types'
import { dataProps } from '@ds/react-utils'
import {
  BaseHeading,
  HeadingLevel,
} from '../../../internal/components/BaseHeading'
import { useThemeStyles } from '../../../theming'
import { TextEllipsis } from '../../TextEllipsis'
import { useHeaderContext } from '../HeaderContext'
import styles from './styles'

export interface HeaderTitleProps {
  /**
   * Text that will be rendered for the HeaderTitle element or to pass Heading..
   */
  children: string
  /**
   * Accepts custom data attributes.
   */
  'data-.*'?: string
  'data-qa'?: string
  /**
   * If provided, renders Header.Title as a heading element <h1>–<h6>.
   */
  level?: HeadingLevel
  /**
   * @ignore @internal
   */
  precededByHeaderAction?: boolean
}

export function HeaderTitle({
  children,
  level,
  precededByHeaderAction = false,
  ...restProps
}: HeaderTitleProps) {
  const headerContext = useHeaderContext()

  const sx = useThemeStyles(styles, {
    ...headerContext,
    precededByHeaderAction,
  })

  return level ? (
    <div {...dataProps(restProps)} css={sx}>
      <BaseHeading
        level={level}
        displayLevel="body-m"
        text={<TextEllipsis>{children}</TextEllipsis>}
      />
    </div>
  ) : (
    <p {...dataProps(restProps)} css={sx}>
      {children}
    </p>
  )
}

HeaderTitle.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
  'data-.*': PropTypes.string,
  precededByHeaderAction: PropTypes.bool,
}

HeaderTitle.displayName = 'Header.Title'
